import { Model } from '@vuex-orm/core';
import { Warehouse, Product, Status } from './models';

export class StockTransaction extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'transactions';

  static fields() {
    return {
      id: this.attr(null),
      dispatching_warehouse_id: this.attr(null),
      receiving_warehouse_id: this.attr(null),
      product_id: this.attr(null),
      dispatching_warehouse: this.belongsTo(Warehouse, 'dispatching_warehouse_id'),
      receiving_warehouse: this.belongsTo(Warehouse, 'receiving_warehouse_id'),
      product: this.belongsTo(Product, 'product_id'),
      status_code: this.attr(null),
      status: this.belongsTo(Status, 'status_code', 'code'),
      quantity: this.attr(null),
      started_at: this.attr(null),
      ended_at: this.attr(null),
      transaction_no: this.attr(null),
      price: this.attr(null),
      order_line_id: this.attr(null),
      job_line_id: this.attr(null),
      unit_type_code: this.attr(null),
    };
  }
}

export default StockTransaction;
